import React, { useState, useEffect } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import paymentIcs from '../../assets/svg/payment_ics.svg';
import { apiCall } from '../../services/api-service';
import './PaymentsOverviewRow.css';

export const PaymentsOverviewRow = () => {
  const [data, setData] = useState([
    { title: 'Total amount paid', value: '₹0' },
    { title: 'Pending amount', value: '₹0' },
    { title: 'Overdue payments', value: '0' },
    { title: 'Avg. payment cycle', value: '0 days' },
    { title: 'Total vendors paid', value: '0' }
  ]);

  useEffect(() => {
    const fetchPaymentsOverview = async () => {
      try {
        const res = await apiCall('get', 'dashboard/payments-overview');
        if (res && res.data && (res.data.status === 'success' || res.data.success === true)) {
          setData(res.data.data);
        }
      } catch (err) {
        console.error('Error fetching payments overview:', err);
      }
    };
    fetchPaymentsOverview();
  }, []);

  return (
    <div className="payments-overview-container mt-3">
      <span className="payments-overview-title">Payments overview</span>
      <Row className="g-3">
        {data.map((item, index) => (
          <Col xs={12} sm={6} md={4} lg={3} xl className="d-flex" key={item.id || index}>
            <Card className="payment-overview-card w-100 border-0">
              <Card.Body className="d-flex align-items-center p-2 gap-3">
                <div className="payment-icon-container">
                  <img
                    src={paymentIcs}
                    alt="Payment Icon"
                    className="payment-icon-img"
                  />
                </div>

                <div className="payment-text-stack">
                  <span className="payment-card-title text-truncate">
                    {item.title}
                  </span>
                  <div className="payment-card-value-container">
                    <span className="payment-card-value text-truncate">
                      {item.value}
                    </span>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};
